import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useEffect, useState } from "react";
import { getUserData } from "../services/authService";

function ProtectedRoute({ children, adminOnly = false }) {
  const { currentUser, loading } = useAuth();
  const [authorized, setAuthorized] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkAccess = async () => {
      if (loading) return;

      if (!currentUser) {
        setChecking(false);
        return;
      }

      if (!adminOnly) {
        setAuthorized(true);
        setChecking(false);
        return;
      }

      const userResult = await getUserData(currentUser.uid);
      if (userResult?.data?.role === "admin") {
        setAuthorized(true);
      }

      setChecking(false);
    };

    checkAccess();
  }, [currentUser, loading, adminOnly]);

  if (loading || checking) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        ⏳ Vérification des accès...
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && !authorized) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default ProtectedRoute;
